<template>
	<div>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn slot="activator" color="primary" dark class="mb-4 mt-4 ml-3">Dodaj osobę do konkursu</v-btn>
			<v-card>
				<v-card-title class="headline blue white--text" >
					Dodaj osobę do konkursu
				</v-card-title>
				<v-card-text>
					wpisz imię i/lub nazwisko osoby, którą chcesz dodać
				</v-card-text>
				<v-card-text>
					<v-autocomplete
						v-model="model"
						:items="items"
						:loading="isLoading"
						color="grey"
						hide-no-data
						hide-selected
						item-text="Description"
						item-value="API"
						label="Osoba do dodania"
						aria-label="contest user"
						for="add-contest-user-menu-add-person"
						id="add-contest-user-menu-add-person"
						placeholder="wpisz kogo chcesz dodać"
						prepend-icon="mdi-database-search"
						return-object
					></v-autocomplete>
				</v-card-text>
				<v-divider></v-divider>
				<v-expand-transition>
					<v-list v-if="model" class="grey lighten-2">
						<v-list-tile
							v-for="(field, i) in fields"
							:key="i"
						>
							<v-list-tile-content>
								<v-list-tile-title v-text="field.value"></v-list-tile-title>
								<v-list-tile-sub-title v-text="field.key"></v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-expand-transition>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:disabled="!model"
						color="primary"
						@click="addUser(model); model = null; dialog = false;"
					>
						zapisz
					</v-btn>
					<v-btn
						:disabled="!model"
						color="primary"
						@click="model = null"
					>
						resetuj
					</v-btn>


					<v-btn
						color="blue"
						@click="dialog = false; model = null"
					>
						anuluj
					</v-btn>

				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

	export default {
		name: "AddContestUserMenu",
		data() {
			return {
				dialog: false,
				user: [],
				model: null,
				isLoading: false,
			};
		},

		columnFilters: {
			"id": false,
			"isLeader": false,
			"userId": false,
		},

		computed: {
			fields() {
				if (!this.model) return [];

				let notFiltered = Object.keys(this.model).map(key => {
					return {
						key: key === "name" ? "Imię" :
							key === "surname" ? "Nazwisko" :
							key === "email" ? "Adres e-mail" :
							key === "role" ? "Rola" :
							key === "Description" ? "Opis" :
							key,
						value: this.model[key] || "-",
					};
				});
				let filtered = Array();
				for (let dict_num in notFiltered) {
					if (notFiltered[dict_num].key !== "userId") {
						filtered.push(notFiltered[dict_num]);
					}
				}
				return filtered;
			},
			items() {
				return this.possibilities.map(entry => {
					const Description = entry.name + " " + entry.surname;

					return Object.assign({}, entry, {Description});
				});
			},
		},

		methods: {
			addUser (model) {
				this.$emit('save', model.userId);
			}
		},

		props: {
			possibilities: Array,
		},
	};
</script>

<style scoped>


.theme--dark .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
	color: #fff !important;
	background-color: #000 !important;
}

.theme--dark .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
	color: #fff;
}

.theme--dark .v-btn[data-v-29bfb792]:not(.v-btn--depressed):not(.v-btn--flat) {
	margin-top: 20px;
	
}
</style>
